module.exports = __webpack_public_path__ + "store/img/DYOT-banner-tag4.70ac5a69.gif";